import { render, staticRenderFns } from "./EditItemModifier.vue?vue&type=template&id=2d559206"
import script from "./EditItemModifier.vue?vue&type=script&lang=js"
export * from "./EditItemModifier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports